import { User } from "../../../commons/auth";

export class RolPolicy {
  view(user: User, context?: any){
    return true
  }
  register(user: User, context?: any){
    return true
  }
}